import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import "./Disclosure.css";

// A disclosure that starts closed.
//
// Used for everything on the review pages that is a full sentence or longer - a
// criterion's justification, the band's reasoning, the printed instructions, the
// page-by-page trail. Expanded by default they would push the figures a reviewer
// came for off the screen; the summary line says what is inside, so opening one
// is a decision rather than a search.
//
// `defaultOpen` exists for the rare panel whose contents ARE the point. It is
// deliberately not the default.
const Disclosure = ({ summary, children, className = "", defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className={`qpe-disclosure${open ? " is-open" : ""} ${className}`}>
      <button
        type="button"
        className="qpe-disclosure-head"
        aria-expanded={open}
        onClick={() => setOpen(!open)}
      >
        <FontAwesomeIcon icon={faChevronRight} className="qpe-disclosure-caret" />
        <span>{summary}</span>
      </button>
      {open && <div className="qpe-disclosure-body">{children}</div>}
    </div>
  );
};

export default Disclosure;
